import { Globals } from "../CoreApp/Globals";

export function endprtimer(msg) {
  var d2 = new Date();
  var e2 = d2.getTime();
  var elapsed = e2 - Globals._pageTimer;
  return elapsed;
}
